import { useEffect } from 'react';
import { create } from 'zustand';

/**
 * Visibility of the floating support button.
 *
 * Kalle's decision 29.7.2026: the button is available around the exercise
 * (waiting, results, host views) but NOT while a participant is answering. The
 * exercise moment is deliberately bare — nothing competes with the topic word.
 *
 * Screens that ARE the exercise call `useHideSupportWidget()`; the counter (not
 * a boolean) keeps things correct when two such screens overlap during a
 * transition.
 */
type SupportWidgetState = {
    hiddenBy: number;
    hide: () => void;
    reveal: () => void;
};

export const useSupportWidgetStore = create<SupportWidgetState>((set) => ({
    hiddenBy: 0,
    hide: () => set((state) => ({ hiddenBy: state.hiddenBy + 1 })),
    reveal: () => set((state) => ({ hiddenBy: Math.max(0, state.hiddenBy - 1) })),
}));

/** Hide the support button while this component (or condition) is live. */
export const useHideSupportWidget = (active = true): void => {
    useEffect(() => {
        if (!active) {
            return;
        }
        const { hide, reveal } = useSupportWidgetStore.getState();
        hide();
        return () => reveal();
    }, [active]);
};
